module.exports = __webpack_public_path__ + "media/images/curatedwith-2a60569ccc2ce40d72a9acdbd6466d94.svg";